import { useSyncExternalStore } from 'react';

/**
 * The payback pairs hidden with "Later" (TMMAPP-0121 item 4): a module-level set of link ids, in
 * memory only, never storage. It lives for the app session: a reload or a new sign-in (which leaves
 * the page for the centralized login) shows the pairs again. Later sends no request.
 */
let hidden: ReadonlySet<number> = new Set();
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

export function hidePaybackForLater(linkId: number): void {
  if (hidden.has(linkId)) return;
  hidden = new Set([...hidden, linkId]);
  emit();
}

export function showPaybacksHiddenForLater(): void {
  if (hidden.size === 0) return;
  hidden = new Set();
  emit();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** The ids hidden for later, re-rendering the caller when the set changes. */
export function usePaybacksHiddenForLater(): ReadonlySet<number> {
  return useSyncExternalStore(
    subscribe,
    () => hidden,
    () => hidden,
  );
}

/** Test seam. */
export function __resetPaybacksHiddenForLater(): void {
  hidden = new Set();
  emit();
}
